import React, {useState, useRef, useEffect} from 'react';
import { ContainerRow, Line, Column, NumberInput, Text, ImageContainer, AlarmConfig, ContainerPump } from '../styles';
// import OperationMode from '../OperationMode';
// import State from '../State';
// import PumpImage from '../PumpImage';
// import CriticoIcon from '../CriticoIcon';
// import AdvertenciaIcon from '../AdvertenciaIcon';
// import Select from '../Select';
// import NonAlarm from '../NonAlarm';
// import ConfigIcon from '../ConfigIcon';
import { OperationMode, State, PumpImage, CriticoIcon, AdvertenciaIcon, NonAlarm, ConfigIcon } from '../../Components';

/**
 * Componente para controle
 * @param {string} name Nome
 * @param {object} Pump Objeto com valores da bomba
 * @param {Array} options Array com opções para unidades de medida ({value e label})
 * @param {string} background cor de fundo do elemento (opcional)
 * @param {string} fatherName nome do elemento pai
 * @param {Function} addComand função para adicionar novo comando
 * @param {boolean} isNewValue caso seja um novo valor inserido pelo usuário
 * @param {boolean} isNewState caso seja um novo estado inserido pelo usuário
 * @param {boolean} isNewOperationMode caso seja um novo modo de operação inserido pelo usuário
 * @returns {ReactComponentElement} 
 */
const MeteringPump = ({id, active, name, pump, options, background, fatherName, addComand, Alarm, Alarms, ShowAlarms, isNewValue, isNewState, isNewOperationMode}) => {
    const MododeOperacao = useRef(pump.filter(item => item.variavel.name.toLowerCase().includes('modo de operação')))
    const PumpState = useRef(pump.filter(item => item.variavel.name.toLowerCase().includes('state') || item.variavel.name.toLowerCase().includes('estado')))
    const Pumpvazao = useRef(pump.filter(item => item.variavel.name.toLowerCase().includes('vazão')))
    
    const [selectedUnit, setSelectedUnit] = useState(Pumpvazao.current[0].variavel.unit);
    const [currentValue, setCurrentValue] = useState(Pumpvazao.current[0].variavel.valor !== null ? Pumpvazao.current[0].variavel.valor : 0);
    const [currentState, setCurrentState] = useState(parseInt(PumpState.current[0].variavel.valor) === 1)
    const [currentOperationMode, setCurrentOperationMode] = useState(parseInt(MododeOperacao.current[0].variavel.valor))

    const [alarmStatus, setAlarmStatus] = useState(0);
    const [isAlarm, setIsAlarm] = useState(false);
    
    useEffect(() => {
        MododeOperacao.current = pump.filter(item => item.variavel.name.toLowerCase().includes('modo de operação'));
        PumpState.current = pump.filter(item => item.variavel.name.toLowerCase().includes('state') || item.variavel.name.toLowerCase().includes('estado'));
        Pumpvazao.current = pump.filter(item => item.variavel.name.toLowerCase().includes('vazão'));

        setSelectedUnit(Pumpvazao.current[0].variavel.unit);
        setCurrentValue(Pumpvazao.current[0].variavel.valor !== null ? Pumpvazao.current[0].variavel.valor : 0);
        setCurrentState(parseInt(PumpState.current[0].variavel.valor) === 1);
        setCurrentOperationMode(parseInt(MododeOperacao.current[0].variavel.valor));
    }, [pump]);

    useEffect(() => {
        if(Alarms.alarmHH && Alarms.alarmH && Alarms.alarmL && Alarms.alarmLL){
            let status = getAlarm(Pumpvazao.current[0].variavel.valor, Alarms.alarmL.variavel.valor, 
                Alarms.alarmLL.variavel.valor, Alarms.alarmH.variavel.valor, Alarms.alarmHH.variavel.valor)
            setAlarmStatus(status);
            setIsAlarm('all')
        }else if(Alarms.alarmHH && Alarms.alarmH){
            let status = getAlarm(Pumpvazao.current[0].variavel.valor, null, 
                null, Alarms.alarmH.variavel.valor, Alarms.alarmHH.variavel.valor)
            setAlarmStatus(status);
            setIsAlarm('h')
        }else if(Alarms.alarmLL && Alarms.alarmL){
            let status = getAlarm(Pumpvazao.current[0].variavel.valor, Alarms.alarmL.variavel.valor, 
                Alarms.alarmLL.variavel.valor, null, null)
            setAlarmStatus(status);
            setIsAlarm('l')
        }
        if(Alarm && Alarm > 2){
            setAlarmStatus(Alarm)
        }
    }, [Alarms, Alarm]);
    
    // Função para pegar o nivel de alerta do alarme
    const getAlarm = (valor, l, ll, h, hh) => {
        if(ll != null && (hh === null || hh === undefined) && ll === l && ll !== 0){
            return 6
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h && hh !== 0){
            return 6
        }
        if(hh === h && ll === l && hh === ll){
            return 6
        }
        if(ll != null && ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return 2;
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return 2;
            }
        }
        if(l != null && l !== 0){
            if (parseFloat(valor) <= parseFloat(l)){
                return 1;
            }
        }
        if(h != null && h !== 0){
            if (parseFloat(valor) >= parseFloat(h)){
                return 1;
            }
        }
        return 0;
    }

    // Método para alterar o modo de operação
    const changeOperationMode = (newState) => {
        ComandConstructor(MododeOperacao.current[0].variavel.id, newState, parseInt(MododeOperacao.current[0].variavel.valor), MododeOperacao.current[0].variavel.name,
            ()=>{setCurrentOperationMode(parseInt(MododeOperacao.current[0].variavel.valor))}, 'modo');
            setCurrentOperationMode(newState);
    }

    // Método para alterar o state
    const changePumpState = (newState) => {
        ComandConstructor(PumpState.current[0].variavel.id, newState, PumpState.current[0].variavel.valor, PumpState.current[0].variavel.name, 
            ()=>{setCurrentState(parseInt(PumpState.current[0].variavel.valor) === 1)}, 'state');
            setCurrentState(newState);
    }

    // const changeSelect = (e) => {
    //     setSelectedUnit(e.target.value);
    // }

    // Função para construir o comando e adicionar a lista
    const ComandConstructor = (comandId, value, oldvalue, childName, cancelComand, type) => {
        let newname = fatherName+'/'+childName;
        addComand([comandId, value], oldvalue, newname, cancelComand, type);
    }

    // Função para exibir os alarmes vinculados ao item, caso haja alarmes
    const openAlarms= () => {
        if(isAlarm === 'all'){
            ShowAlarms(Pumpvazao.current[0].variavel.name ,Alarms.alarmL.variavel, Alarms.alarmLL.variavel, Alarms.alarmH.variavel, Alarms.alarmHH.variavel)
        }else if(isAlarm === 'h'){
            ShowAlarms(Pumpvazao.current[0].variavel.name, null, null, Alarms.alarmH.variavel, Alarms.alarmHH.variavel)
        }else if (isAlarm === 'l'){
            ShowAlarms(Pumpvazao.current[0].variavel.name, Alarms.alarmL.variavel, Alarms.alarmLL.variavel, null, null)
        }
    }

    return (
        <ContainerPump>
            {isAlarm === 'all' || isAlarm === 'h' || isAlarm === 'l' ?
                <AlarmConfig $isAlarm={isAlarm === 'all' || isAlarm === 'h' || isAlarm === 'l'}  onClick={() => openAlarms()}>
                    <ConfigIcon/>
                </AlarmConfig> : <AlarmConfig/>
            }

            <ContainerRow 
                $background={background} 
                $isAlarm={isAlarm === 'all' || isAlarm === 'h' || isAlarm === 'l'} 
                $alarm={alarmStatus} onDoubleClick={() => openAlarms()}>
                <Column $width={'80%'}>
                    <Line $lower={true}>
                        <Column $width={'60%'}>
                            <Text $weight={'700'}>Vazão {name}</Text>
                        </Column>
                        <Column $width={'40%'}>
                            <OperationMode id={active && id} isNewValue={isNewOperationMode} State={currentOperationMode} onChange={(newState) => changeOperationMode(newState)}/>
                        </Column>
                    </Line>
                    <Line>
                        <Column $width={'30%'}>
                            <NumberInput value={currentValue} isNewValue={isNewValue}
                            onBlur={()=> ComandConstructor(Pumpvazao.current[0].variavel.id, currentValue, Pumpvazao.current[0].variavel.valor,
                            Pumpvazao.current[0].variavel.name, () => setCurrentValue(Pumpvazao.current[0].variavel.valor !== null ? Pumpvazao.current[0].variavel.valor : 0))} 
                            type="number"
                            onChange={(e) => {setCurrentValue(e.target.value);}}/>
                        </Column>
                        <Column $width={'30%'}>
                            <Text $weight={'600'}>{selectedUnit}</Text>
                            {/* <Select options={options} value={selectedUnit} onChange={changeSelect}/> */}
                        </Column>
                        <Column $width={'30%'}>
                            <State isNewValue={isNewState} State={currentState} onChange={(newState) => changePumpState(newState)}/>
                        </Column>
                    </Line>
                </Column>

                <Column $width={'20%'}>
                    <ImageContainer>
                        <PumpImage/>
                        {alarmStatus === 2 ? <CriticoIcon width={'10'} height={'10'}/> : 
                        alarmStatus === 1 ? <AdvertenciaIcon width={'10'} height={'10'}/> : 
                        alarmStatus === 6 ? <NonAlarm width={'10'} height={'10'}/> :
                        null}
                    </ImageContainer>
                </Column>
            </ContainerRow>
        </ContainerPump>
    );
}

export default MeteringPump;